export const QualificationStatusList = [
  {id: 1, label: 'Non-qualified'},
  {id: 2, label: 'In Qualification'},
  {id: 3, label: 'Qualified'},
];

export const QualificationStatusConst = {
  NON_QUALIFIED: 1,
  IN_QUALIFICATION: 2,
  QUALIFIED: 3,
};
